var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlassUpArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30.55 35.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "glow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 4
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "SourceGraphic",
    stdDeviation: 1.5
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,15.18c0-.11.1-.36.15-.47C4.94,9.79,9.82,4.94,14.72.13c.51-.24,1.08-.13,1.49.25l14.13,14.18c.43.62.2,1.49-.47,1.82-.04.02-.31.13-.33.13h-7.93v17.77c0,.37-.63.99-1.03.99h-10.53c-.45,0-1.08-.6-1.08-1.03v-17.72H1.08C.57,16.51.06,15.84,0,15.36c0-.05,0-.13,0-.18Z",
    fill: "rgba(255, 255, 255, 0.03)",
    filter: "url(#glow)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0,15.18c0-.11.1-.36.15-.47C4.94,9.79,9.82,4.94,14.72.13c.51-.24,1.08-.13,1.49.25l14.13,14.18c.43.62.2,1.49-.47,1.82-.04.02-.31.13-.33.13h-7.93v17.77c0,.37-.63.99-1.03.99h-10.53c-.45,0-1.08-.6-1.08-1.03v-17.72H1.08C.57,16.51.06,15.84,0,15.36c0-.05,0-.13,0-.18Z",
    fill: "rgba(0, 0, 0, 0.08)",
    filter: "url(#shadow)",
    transform: "translate(0, 0.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0,15.18c0-.11.1-.36.15-.47C4.94,9.79,9.82,4.94,14.72.13c.51-.24,1.08-.13,1.49.25l14.13,14.18c.43.62.2,1.49-.47,1.82-.04.02-.31.13-.33.13h-7.93v17.77c0,.37-.63.99-1.03.99h-10.53c-.45,0-1.08-.6-1.08-1.03v-17.72H1.08C.57,16.51.06,15.84,0,15.36c0-.05,0-.13,0-.18Z",
    fill: "rgba(255, 255, 255, 0.15)",
    stroke: "rgba(255, 255, 255, 0.2)",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.97,34.27v-17.72H1.08C.57,16.51.06,15.84,0,15.36l0-.18c0-.11.1-.36.15-.47L14.72.13",
    fill: "none",
    stroke: "rgba(255, 255, 255, 0.15)",
    strokeWidth: 1,
    strokeLinecap: "butt"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.72.13c.51-.24,1.08-.13,1.49.25l14.13,14.18c.43.62.2,1.49-.47,1.82-.04.02-.31.13-.33.13h-7.93",
    fill: "none",
    stroke: "rgba(255, 255, 255, 0.15)",
    strokeWidth: 1,
    strokeLinecap: "butt"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlassUpArrow);
export default __webpack_public_path__ + "static/media/glassUpArrow.40411b81a52a5b72f80a48d99c67b69b.svg";
export { ForwardRef as ReactComponent };